import { saturate, lighten } from 'polished';

import { colors as internalColors } from '@crm-framework/theme';

export const tagColors = {
  gray: 'gray',
  brown: 'brown',
  black: 'black',
  yellow: 'yellow',
  orange: 'orange',
  mustard: saturate(0.5, internalColors.Y5),
  red: 'red',
  pink: internalColors.R2,
  purple: internalColors.PURPLE,
  green: saturate(0.5, internalColors.SUCCESS),
  herbal: internalColors.HERBAL,
  aquamarine: lighten(0.1, internalColors.G5),
  blue: 'blue',
  'electric-blue': saturate(0.5, internalColors.B3),
  lightskyblue: 'lightskyblue',
  azure: lighten(0.1, internalColors.G3),
  white: 'white',
};
